import { IconName, Icon } from "@/components";
import { useMediaQuery } from "@/hooks";
import { useI18n } from "@/lib/i18n/i18n_provider";
import { Spacer } from "@/offering/spacer";
import classNames from "classnames";
import React from "react";
import { Dropdown } from "react-bootstrap";

interface LocationFilterDropdownProps {
  iconName: IconName;
  value?: string;
  label: string;
  placeholder?: string;
  testID?: string;
  dropdownElement: JSX.Element;
  show?: boolean;
  onToggle?: (show: boolean) => void;
  highlightBorder?: boolean;
}

export function LocationFilterDropdown(props: LocationFilterDropdownProps) {
  const { fbt } = useI18n();
  const { device } = useMediaQuery();
  const isMobile = device === "mobile";

  const {
    iconName,
    value,
    placeholder = fbt("Any"),
    label,
    testID,
    dropdownElement,
    show,
    onToggle,
    highlightBorder,
  } = props;

  return (
    <div>
      <Dropdown
        className="checkout-box-picker rounded"
        style={{
          minHeight: "unset",
          border: "1px solid",
          borderColor: highlightBorder
            ? "var(--bs-primary)"
            : "rgba(130, 128, 142, 0.5)",
        }}
        show={show}
        onToggle={onToggle}
      >
        <Dropdown.Toggle
          className="w-100 d-flex align-items-center text-left p-2"
          style={{ height: 40 }}
        >
          {!isMobile && (
            <>
              <Icon name={iconName} />
              <Spacer size={8} direction="horizontal" />
              <b>{label}:</b>
              <Spacer size={4} direction="horizontal" />
            </>
          )}
          <div
            className={classNames(
              "d-flex align-items-center",
              isMobile ? "w-100 justify-content-between" : "g-3"
            )}
          >
            {value ? (
              <div
                data-testid={`${testID}-value`}
                style={{ overflow: "hidden", textOverflow: "ellipsis" }}
              >
                {value}
              </div>
            ) : (
              <div>{placeholder}</div>
            )}
            <Spacer size={16} direction="horizontal" />
            <div>
              <Icon name="fi-chevron-down" color="#82808E" />
            </div>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu>{dropdownElement}</Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
